import SmoothScroll from 'smooth-scroll';

let smoothScroll = new SmoothScroll('a[href*="#"]', {
  header: '[data-scroll-header]',
  speed: 400,
  updateURL: false,
  speedAsDuration: true
});
